import prefixApi from '../../api/prefix';
import ErrorHelper from '../../helpers/ErrorHelper';
import { showErrorMessage } from '../../dialogs';

export default {
    namespaced: true,
    state: {
        prefixes: null,
        createError: null,
    },
    mutations: {
        setPrefixes(state, value) {
            state.prefixes = value;
        },
        addPrefix(state, prefix) {
            state.prefixes.push(prefix);
        },
        setCreateError(state, value) {
            state.createError = value;
        },
        openEditing(state, prefix) {
            if (state.prefixes) {
                state.prefixes.forEach((x) => {
                    x.editing = x.ID == prefix.ID;
                });
            }
        },
    },
    getters: {
        getPrefixes(state) {
            return state.prefixes;
        },
        getPrefixById: (state) => (id) => {
            if (!id) {
                return null;
            }
            if (!state.prefixes) {
                return null;
            }
            return state.prefixes.find((x) => x.ID == id);
        },
        getChildren: (state) => (parentId) => {
            if (!state.prefixes) {
                return null;
            }
            return state.prefixes.filter((x) => x.parent == parentId);
        },
        getLevel: (state) => (parentId, level) => {
            if (!state.prefixes) {
                return null;
            }
            return state.prefixes.filter(
                (x) => x.level == level && x.parent == parentId
            );
        },
        getFreePrefixes: (state) => (level) => {
            if (!state.prefixes) {
                return [];
            }
            return state.prefixes.filter(
                (x) => x.parent == null && x.level == level
            );
        },
        getCreateError: (state) => state.createError,
    },
    actions: {
        updatePrefixParent({ commit, dispatch }, { prefix, parentId }) {
            const payload = { ...prefix, parent: parentId };
            prefixApi
                .updatePrefix(payload)
                .catch((error) => {
                    showErrorMessage(
                        'Verplaatsen van prefix mislukt: ' +
                            ErrorHelper.parseError(error.response.data)
                    );
                })
                .finally(() => {
                    dispatch('loadPrefixes');
                });
        },
        removePrefixById({ commit, dispatch }, id) {
            prefixApi
                .removePrefix(id)
                .then(() => {
                    dispatch('loadPrefixes');
                })
                .catch((error) => {
                    showErrorMessage(
                        ErrorHelper.parseError(error.response.data)
                    );
                });
        },
        createPrefix({ commit, state }, { parent, level }) {
            commit('setCreateError', null);
            prefixApi
                .createPrefix(level, parent)
                .then((response) => {
                    const prefix = response.data.data;
                    prefix.editing = true;
                    commit('addPrefix', prefix);
                })
                .catch((error) => {
                    commit('setCreateError', error.response.data);
                });
        },
        loadPrefixes({ commit }) {
            commit('setPrefixes', null);
            prefixApi.fetchAllPrefixes().then((response) => {
                const prefixes = response.data.data;
                prefixes.forEach((x) => {
                    x.editing = false;
                });
                commit('setPrefixes', prefixes);
            });
        },
    },
};
